import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/wechat-callback',
    name: 'WechatCallback',
    component: () => import('../views/WechatAuth.vue')
  },
  {
    path: '/ls',
    name: 'WechatLoginList',
    component: () => import('../views/WechatLogin.vue'),
    meta: { returnUrl: 'users' }
  },
  {
    path: '/lsm',
    name: 'WechatLoginMy',
    component: () => import('../views/WechatLogin.vue'),
    meta: { returnUrl: 'my' }
  },
  {
    path: '/lsg',
    name: 'WechatLoginGroup',
    component: () => import('../views/WechatLogin.vue'),
    meta: { returnUrl: 'chat-groups' }
  },
  {
    path: '/lsr',
    name: 'WechatLoginRequest',
    component: () => import('../views/WechatLogin.vue'),
    meta: { returnUrl: 'request-list' }
  },
  {
    path: '/users',
    name: 'UserList',
    component: () => import('../views/UserList.vue')
  },
  {
    path: '/chat-groups',
    name: 'ChatGroups',
    component: () => import('../views/ChatGroups.vue')
  },
  {
    path: '/user/:id',
    name: 'UserProfile',
    component: () => import('../views/UserProfile.vue')
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('../views/My.vue')
  },
  {
    path: '/my/profile',
    name: 'MyProfile',
    component: () => import('../views/MyProfile.vue')
  },
  {
    path: '/visit-data',
    name: 'VisitData',
    component: () => import('@/views/VisitData.vue')
  },
  {
    path: '/follow-data',
    name: 'FollowData',
    component: () => import('@/views/FollowData.vue')
  },
  {
    path: '/request-list',
    name: 'RequestList',
    component: () => import('@/views/RequestList.vue')
  },
  {
    path: '/register/profile',
    name: 'RegisterProfile',
    component: () => import('@/views/RegisterProfile.vue')
  },
  {
    path: '/register/expectation',
    name: 'RegisterExpectation',
    component: () => import('@/views/RegisterExpectation.vue')
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('@/views/UserAgreement.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/articles',
    name: 'Articles',
    component: () => import('@/views/Articles.vue')
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import('@/views/ArticleDetail.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 